module["exports"] = [
  "gmail.com",
  "yahoo.com",
  "hotmail.com"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/de/internet/free_email.js
 ** module id = 338
 ** module chunks = 0
 **/